import { createFileRoute, redirect } from "@tanstack/react-router";

// Page fusionnée avec /architecte-interieur-lyon (arrondissements trop proches).
export const Route = createFileRoute("/architecte-interieur-lyon-2")({
  beforeLoad: () => {
    throw redirect({ to: "/architecte-interieur-lyon", statusCode: 301 });
  },
});
